import logo from "../assets/images/logo.svg";
import logo_white from "../assets/images/logo-white.svg";
import skating_man_video from "../assets/videos/skiing_man.mp4";

export const IMAGE_PATHS = {
  logo,
  logo_white,
  skating_man_video,
};
